import { connect } from 'react-redux';

import Day from '~/Components/Pages/Calendar/WeekView/Day';
import { formatEvents } from '~/Context/Event';
import { filterEventsByCalendarDisplay } from '~/Redux/Modules/Events/selectors';

const mapStateToProps = ({ Events, CalendarAccounts }) => {
  const calendarDisplayOptions = {
    includeMonthView: true,
    includeWeekView: true,
    includeDayView: false,
  };
  const calendarMap = CalendarAccounts.calendarMap;
  const filteredEvents = filterEventsByCalendarDisplay(
    Events.formattedData,
    calendarDisplayOptions,
    calendarMap
  );
  return {
    events: filteredEvents,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Day);
